export default [
    { title: "arama", url: "/search" },
    { title: "yeni üyeler", url: "/search?newMember=true" },
    { title: "online üyeler", url: "/search?isOnline=true" },
];
